<template>
  <div />
</template>

<script>
export default {
  mounted() {
    console.log('mounted No')
  },
}
</script>

<style>

</style>